import React from 'react'
import { withRouter } from 'react-router'
import { Label, Button } from 'semantic-ui-react'
import './Guide.scss'

const Guide2 = props => {

    const goToSignIn = () => {
        props.history.push('/signin')
    }

    return (
        <div className='guide'>
            <h1 >¿Qué esperas?</h1>
            <Label style={{ color: '#606060' }}>Empieza a <b style={{ marginLeft: '5px', marginRight: '5px', color: 'black' }}>monetizar</b> y a <b style={{ marginLeft: '5px', marginRight: '5px', color: 'black' }}>privatizar</b> tus datos</Label>

            <Button 
                onClick={goToSignIn}>
                Siguiente
            </Button>

            <div className='intro'>
                <span onClick={goToSignIn}>
                    Saltar intro
                </span>

                <div className='carousel'>
                    <div className='carousel_circle' />
                    <div className='carousel_circle' />
                    <div className='carousel_circle' style={{ backgroundColor: '#68bbe3' }} />
                    <div className='carousel_circle' />
                </div>

                
            </div>
        </div>
    )
}

export default withRouter(Guide2)
